import { Component } from '@angular/core';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  version = environment.version;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/app.component.ts